import { render, staticRenderFns } from "./TranshHistory.vue?vue&type=template&id=54601d50&scoped=true"
import script from "./TranshHistory.vue?vue&type=script&lang=js"
export * from "./TranshHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54601d50",
  null
  
)

export default component.exports